import { ssoClient } from "@better-auth/sso/client"
import {
	adminClient,
	inferAdditionalFields,
	lastLoginMethodClient,
	organizationClient
} from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"
import { getApiBaseUrl } from "~/lib/client-url"
import { getNativeAuthToken } from "~/lib/native-auth-token"
import type { auth } from "~/server/auth"

export const authClient = createAuthClient({
	baseURL: getApiBaseUrl(),
	fetchOptions: {
		credentials: "include",
		customFetchImpl: (input, init) => {
			const headers = new Headers(init?.headers)
			const token = getNativeAuthToken()
			if (token) headers.set("authorization", `Bearer ${token}`)
			return fetch(input, { ...init, headers })
		}
	},
	plugins: [
		lastLoginMethodClient(),
		adminClient(),
		organizationClient({
			teams: {
				enabled: true
			}
		}),
		ssoClient(),
		inferAdditionalFields<typeof auth>()
	]
})

export type ActiveOrganization = typeof authClient.$Infer.ActiveOrganization
export type Organization = typeof authClient.$Infer.Organization
export type Team = typeof authClient.$Infer.Team
